import { render } from "./liver_enzymes.vue?vue&type=template&id=0197296b&scoped=true"
import script from "./liver_enzymes.vue?vue&type=script&lang=js"
export * from "./liver_enzymes.vue?vue&type=script&lang=js"

import "./liver_enzymes.vue?vue&type=style&index=0&id=0197296b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0197296b"]])

export default __exports__